export default class Gravity
{
    // x: {gravity: 0.35, using: "width"},
    // y: {gravity: 0.9, using: "height"}
    //

    get x ()
    {
        return this.m_x;
    }

    set x (val)
    {
        this.m_x.ingest(val);
    }

    get y ()
    {
        return this.m_y;
    }

    set y (val)
    {
        this.m_y.ingest(val);
    }

    constructor (val = null)
    {

        this.m_x = new UsingGravity(0, "width");
        this.m_y = new UsingGravity(0, "height");

        if (val)
        {
            this.ingest(val);
        }

    }

    ingest (val)
    {
        this.x = val.x;
        this.y = val.y;
    }
}

class UsingGravity
{
    get gravity ()
    {
        return this.m_gravity;
    }

    set gravity (val)
    {
        this.m_gravity = val;
    }

    get using ()
    {
        return this.m_using;
    }

    set using (val)
    {
        this.m_using = val;
    }

    constructor (gravity, using)
    {
        this.m_gravity = gravity;
        this.m_using = using;

    }

    ingest (val)
    {
        this.gravity = val.gravity;
        this.using = val.using;
    }
}